<!-- =========================================================================================
  File Name: Edit.vue
  Description: Partner Edit Page
========================================================================================== -->

<template>
  <div id="page-partner-edit">

    <vs-alert color="danger" title="Партнер не найден" :active.sync="partner_ready && !partnerLocal.partid">
      <span>Партнер с идентификатором: {{ $route.params.partnerId }} не найден. </span>
      <span>
        <span>Перейти в </span><router-link :to="{name:'apps-partners-list'}" class="text-inherit underline">список партнеров</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="partner_ready && partnerLocal.partid">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          
          <vs-tab label="Информация" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <tab-information class="mt-4" />
            </div>
          </vs-tab>

          <vs-tab label="Контакты" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <tab-contacts class="mt-4" />
            </div>
          </vs-tab>

          <vs-tab label="Описание" icon-pack="feather" icon="icon-file-text">
            <div class="tab-text">
              <tab-description class="mt-4" />
            </div>
          </vs-tab>

        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import TabInformation from "./TabInformation.vue"
import TabContacts     from "./TabContacts.vue"
import TabDescription      from "./TabDescription.vue"

// Store Module
import modulePartner from '@/store/partner/modulePartner.js'

export default {
  components: {
    TabInformation,
    TabContacts,
    TabDescription,
  },
  data() {
    return {
      partner_ready: false,
      activeTab: 0,
    }
  },
  computed: {
    partnerLocal() {
      return this.$store.getters["partner/getPartner"] ? this.$store.getters["partner/getPartner"] : { partid: 0 }
    },
  },
  created() {
    if (!modulePartner.isRegistered) {
      this.$store.registerModule('partner', modulePartner)
      modulePartner.isRegistered = true
    }

    // тут что-то не так. мне кажется, не должно быть здесь упоминание об api-шном параметре partid, тут нужно пересмотреть подход
    this.$store.dispatch("partner/fetchPartner", { partid: this.$route.params.partnerId })
    .then(() => {
      this.partner_ready = true
    })

    this.$store.dispatch("partner/fetchPrograms")
  }
}

</script>
